/**
 * Centralized definitions for channel colors, icons, and labels
 * Used across messaging templates and campaigns
 *
 * Channel Type IDs are loaded from ChannelType.enum.js
 */

import { channelType } from 'src/shared/inf-tabela-descricao/ChannelType.enum.js'

let cachedMappings = null

function getMappings () {
  if (cachedMappings) {
    return cachedMappings
  }

  const c = channelType()

  cachedMappings = {
    colors: {
      [c.EMAIL.key]: '#0e88e4',
      [c.SMS.key]: '#1a1824',
      [c.WHATSAPP.key]: '#039e3c',
      [c.PUSH_NOTIFICATION.key]: '#cc1717'
    },
    icons: {
      [c.EMAIL.key]: 'mail',
      [c.SMS.key]: 'sms',
      [c.WHATSAPP.key]: 'chat',
      [c.PUSH_NOTIFICATION.key]: 'smartphone'
    },
    labels: {
      [c.EMAIL.key]: 'Email',
      [c.SMS.key]: 'SMS',
      [c.WHATSAPP.key]: 'WhatsApp',
      [c.PUSH_NOTIFICATION.key]: 'Push'
    }
  }

  return cachedMappings
}

export function getChannelColor (channelId) {
  const mappings = getMappings()
  return mappings.colors[channelId] || '#999999'
}

export function getChannelIcon (channelId) {
  const mappings = getMappings()
  return mappings.icons[channelId] || 'rss_feed'
}

export function getChannelLabel (channelId) {
  const mappings = getMappings()
  return mappings.labels[channelId] || ''
}
